import { ASSET_PATH } from 'constants/assets';

const { REACT_APP_ASSET_BASE_URL } = process.env;
export const getImageURL = ({ assetName }: { assetName: ASSET_PATH }) =>
  `${REACT_APP_ASSET_BASE_URL}/images/client/${assetName}`;

export const getAssetURL = ({ path }: { path: ASSET_PATH }) =>
  `${REACT_APP_ASSET_BASE_URL}/${path}`;
